import React, { useState } from 'react'

import { Box, Button, List, ListItem, TextField } from '@mui/material'
import SchoolIcon from '@mui/icons-material/School'
import SpeedIcon from '@mui/icons-material/Speed'

const calcColor = (packages, maxPackages) => {
    if (!maxPackages) return 'green'
    const ratio = packages / maxPackages
    if (ratio >= 1) return '#e70000'
    if (ratio >= 0.9) return '#ff5e5e'
    if (ratio >= 0.7) return 'orange'
    if (ratio >= 0.5) return '#8f8f02'
    return 'green'
}

// Simplified native equivalent of kwik-assistant's TopMenu, scoped to what
// the two chat surfaces need: current knowledge base name, package balance,
// and the switcher popup. The admin nav (knowledge bases / curation /
// history / personas) isn't chat, and stays on the embedded widget.
const KnowledgeBasePicker = ({
    knowledgeBases,
    selectedBase,
    onSelect,
    open,
    onToggle,
    packages,
    maxPackages,
}) => {
    const bases = Object.values(knowledgeBases || {})
    const [searchTerm, setSearchTerm] = useState('')
    const filteredBases = searchTerm.trim()
        ? bases.filter((kb) => kb.name.toLowerCase().includes(searchTerm.trim().toLowerCase()))
        : bases

    const closePicker = () => {
        setSearchTerm('')
        onToggle(false)
    }

    return (
        <Box className="cortex-package-box" sx={{ color: calcColor(packages, maxPackages) }}>
            {packages}/{maxPackages}
            <SpeedIcon fontSize="small" />
            {open &&
                <Box className="cortex-select-kb-pop-up">
                    <Box onClick={closePicker} className="cortex-select-kb-background" />
                    <TextField
                        size="small"
                        placeholder="Buscar base..."
                        fullWidth
                        value={searchTerm}
                        onChange={({ target }) => setSearchTerm(target.value)}
                        autoFocus
                    />
                    {filteredBases.length === 0 &&
                        <Box className="cortex-kb-empty-list">
                            {searchTerm.trim() ? 'Nenhuma base encontrada.' : 'Nenhuma base disponível.'}
                        </Box>
                    }
                    <List dense>
                        {filteredBases.map((kb) => (
                            <ListItem
                                key={`kb-list-item-${kb.id}`}
                                className={`cortex-kb-list-item ${kb.id === selectedBase ? 'selected' : ''}`}
                                onClick={() => { onSelect(kb.id, kb.type === 'file'); closePicker() }}
                            >
                                {kb.name.replace(/ :::: \d+/g, '')}
                            </ListItem>
                        ))}
                    </List>
                </Box>
            }
        </Box>
    )
}

export const KnowledgeBaseButton = ({ onClick, disabled }) => (
    <Button
        className="cortex-send-button cortex-iconbutton knowledge assistant-btn"
        color="primary"
        variant="contained"
        size="small"
        onClick={onClick}
        disabled={disabled}
    >
        <SchoolIcon />
    </Button>
)

export default KnowledgeBasePicker
